import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setSearchText } from "../../../store/documentShow";
import { selectSearchText } from "../../../store/documentShow/selectors/selectSearchText";

export const SignerSearchBar = () => {
  const dispatch = useDispatch();
  const searchText = useSelector(selectSearchText);
  return (
    <IonSearchbar
      placeholder="Buscar usuario"
      debounce={900}
      value={searchText}
      onIonChange={(e) => dispatch(setSearchText(e.detail.value || ""))}
      autocomplete="off"
    />
  );
};
